export async function fetchUserData(userHandle) {
  // Convert userHandle to lowercase for case-insensitive matching
  const lowercaseHandle = userHandle?.toLowerCase();
  const apiUrl = `https://le5k0ml4f0.execute-api.us-east-1.amazonaws.com/get-user-reviews?userHandle=${encodeURIComponent(lowercaseHandle)}`;
  const response = await fetch(apiUrl, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
  
  if (!response.ok) {
    throw new Error("Failed to fetch user data");
  }
  
  return response.json();
} 